/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Theirs/view.blocks to change it.
import Attachments from './Attachments/index'
import CardMessageNoAvatar from 'DesignSystem/CardMessageNoAvatar/index'
import Message from './Message/index'
import React from 'react'
import SentTime from './SentTime/index'
import User from './User/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Theirs({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Internal/Content/Theirs"
  
}) {
  return (<React.Fragment
>
<CardMessageNoAvatar
  viewPath={`${viewPath}/CardMessageNoAvatar`}
 marginLeft={0}
 alignSelf="flex-start"
 alignItems="flex-start"
 backgroundColor="rgba(0,0,0,0.05)"
>
{childProps => (
<React.Fragment>
<Message
{...childProps}
  viewPath={`${viewPath}/Message`}
/>
<div
  data-testid="Theirs.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<User
  viewPath={`${viewPath}/User`}
/>
<SentTime
  viewPath={`${viewPath}/SentTime`}
/>
</div>
<Attachments
{...childProps}
  viewPath={`${viewPath}/Attachments`}
/>
</React.Fragment>
)}
</CardMessageNoAvatar>
{children}
</React.Fragment>)
}